"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "refresh-cw",
    transform: "translate(2.000000, 4.000000)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
      id: "Shape",
      points: "20 0.909090909 20 6.36363636 14.5454545 6.36363636"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
      id: "Shape",
      points: "0 15.4545455 0 10 5.45454545 10"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2.28181818,5.45454545 C3.21898331,2.80619241 5.44933379,0.823834768 8.18935156,0.20387115 C10.9293693,-0.416092468 13.7958553,0.413041575 15.7818182,2.4 L20,6.36363636 M0,10 L4.21818182,13.9636364 C6.20414469,15.9505948 9.07063066,16.7797288 11.8106484,16.1597652 C14.5506662,15.5398016 16.7810167,13.557444 17.7181818,10.9090909",
      id: "Shape"
    })]
  })
}));